import Button from "../../fragments/Button";
import { useNotifications } from "../../hooks/useNotifications";

const ShareButton = () => {
  const { addNotification } = useNotifications();

  return (
    <Button
      onClick={() => {
        let url = document.location.href;
        const canonicalElement = document.querySelector("link[rel=canonical]");
        if (canonicalElement !== null) {
          url = canonicalElement.href;
        }
        if (navigator.share) {
          navigator.share({
            title: gettext("Play TriviaRoyale!"),
            text: gettext(
              "Compete against me for the highscore on TriviaRoyale!"
            ),
            url: url,
          });
        } else {
          const text = `${gettext(
            "Play against me on TriviaRoyale!"
          )} - ${url}`;
          navigator.clipboard.writeText(text);
          addNotification({
            level: "blue",
            message: "Link copied to your clipboard!",
          });
        }
      }}
      primary
      className="my-2 w-full"
    >
      {gettext("Invite friends")}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="ml-2 h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
        />
      </svg>
    </Button>
  );
};
export default ShareButton;
